import Vue from 'vue'
import App from './App.vue'
import Layout from './views/mobile/layout.vue'
import router from './router'
import axios from 'axios'
import qs from 'qs'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlayer)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
	//完全显示的时候加载
	preLoad: 1,
	//失败时显示的图片
	error: require('./assets/img/error.png'),
	//加载时显示的GIF图
	loading: require('./assets/img/loading.gif'),
	//尝试加载几次
	attempt: 1
});

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
	// ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
	ak: 'mtUjZdQKZyQDtgMphw51oFY4kPBjw7L4'
})

import VueWaypoint from 'vue-waypoint'
// Waypoint plugin
Vue.use(VueWaypoint)

Vue.config.productionTip = false

//设置超时时间
axios.defaults.timeout = 5000
//设置api地址
//全局定义axios
axios.defaults.baseURL = 'https://oa.jxth.com.cn/'
Vue.prototype.$http = axios
Vue.prototype.$qs = qs //全局注册，使用方法为:this.$qs(axios.post传参数使用)
Vue.prototype.$baseURL = 'https://oa.jxth.com.cn'

// if(document.body.clientWidth < 415){
// 	new Vue({
// 		el: '#app',
// 		router,
// 		components:{ Layout },
// 	    template: '<Layout/>',
// 		render: h => h(Layout)
// 	})
// }else{
// 	new Vue({
// 		router,
// 		render: h => h(App)
// 	}).$mount('#app')
// }

function isMobileDevice() {
	return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || document.body.clientWidth < 768;
}

const initializeVue = (component) => {
	new Vue({
		router,
		render: h => h(component)
	}).$mount('#app');
};

if (isMobileDevice()) {
	import('./views/mobile/layout.vue').then(Layout => {
		initializeVue(Layout.default);
	});
} else {
	import('./App.vue').then(App => {
		initializeVue(App.default);
	});
}
